module.exports = __webpack_public_path__ + "static/img/btn_99_1.97a68e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/btn_99_1.png
// module id = t4CN
// module chunks = 0